import React from 'react';
import {
  Box, SimpleGrid, Stat, StatLabel, StatNumber, StatHelpText,
  StatArrow, Heading, Card, CardBody, CardHeader, Text,
  useColorModeValue, Icon, Flex, Progress, VStack
} from '@chakra-ui/react';
import { 
  MdAssessment, MdPeople, MdAttachMoney, MdTrendingUp,
  MdFolder, MdPendingActions
} from 'react-icons/md';

const GestorComercialDashboard = () => {
  const bgCard = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const textColor = useColorModeValue('gray.700', 'gray.200');
  const iconBg = useColorModeValue('blue.50', 'blue.900');
  const iconColor = useColorModeValue('blue.500', 'blue.200');

  return (
    <Box>
      <Heading size="lg" mb={6} color={textColor}>
        Dashboard - Gestor Comercial
      </Heading>

      <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={6} mb={8}>
        <Card bg={bgCard} borderColor={borderColor} borderWidth="1px">
          <CardBody>
            <Flex align="center" justify="space-between">
              <Stat>
                <StatLabel color="gray.500">Precatórios Recebidos</StatLabel>
                <StatNumber fontSize="2xl">248</StatNumber>
                <StatHelpText>
                  <StatArrow type="increase" />
                  12% este mês
                </StatHelpText>
              </Stat>
              <Box bg={iconBg} p={3} borderRadius="lg">
                <Icon as={MdFolder} boxSize={6} color={iconColor} />
              </Box>
            </Flex>
          </CardBody>
        </Card>

        <Card bg={bgCard} borderColor={borderColor} borderWidth="1px">
          <CardBody>
            <Flex align="center" justify="space-between">
              <Stat>
                <StatLabel color="gray.500">Para Distribuir</StatLabel>
                <StatNumber fontSize="2xl">156</StatNumber>
                <StatHelpText color="orange.500">
                  Aguardando distribuição
                </StatHelpText>
              </Stat>
              <Box bg="orange.50" p={3} borderRadius="lg">
                <Icon as={MdPendingActions} boxSize={6} color="orange.500" />
              </Box>
            </Flex>
          </CardBody>
        </Card>

        <Card bg={bgCard} borderColor={borderColor} borderWidth="1px">
          <CardBody>
            <Flex align="center" justify="space-between">
              <Stat>
                <StatLabel color="gray.500">Equipe Comercial</StatLabel>
                <StatNumber fontSize="2xl">12</StatNumber>
                <StatHelpText>
                  Membros ativos
                </StatHelpText>
              </Stat>
              <Box bg="green.50" p={3} borderRadius="lg">
                <Icon as={MdPeople} boxSize={6} color="green.500" />
              </Box>
            </Flex>
          </CardBody>
        </Card>

        <Card bg={bgCard} borderColor={borderColor} borderWidth="1px">
          <CardBody>
            <Flex align="center" justify="space-between">
              <Stat>
                <StatLabel color="gray.500">Valor Total</StatLabel>
                <StatNumber fontSize="xl">R$ 4.8M</StatNumber>
                <StatHelpText>
                  <StatArrow type="increase" />
                  8.3%
                </StatHelpText>
              </Stat>
              <Box bg="purple.50" p={3} borderRadius="lg">
                <Icon as={MdAttachMoney} boxSize={6} color="purple.500" />
              </Box>
            </Flex>
          </CardBody>
        </Card>
      </SimpleGrid>

      <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={6}>
        <Card bg={bgCard} borderColor={borderColor} borderWidth="1px">
          <CardHeader>
            <Heading size="md">Distribuição por Estado</Heading>
          </CardHeader>
          <CardBody>
            <VStack spacing={4} align="stretch">
              {[
                { state: 'BA', count: 89, percent: 36 },
                { state: 'MA', count: 67, percent: 27 },
                { state: 'SP', count: 45, percent: 18 },
                { state: 'RJ', count: 32, percent: 13 },
                { state: 'Outros', count: 15, percent: 6 }
              ].map((item) => (
                <Box key={item.state}>
                  <Flex justify="space-between" mb={2}>
                    <Text fontWeight="medium">{item.state}</Text>
                    <Text color="gray.500">{item.count} precatórios</Text>
                  </Flex>
                  <Progress
                    value={item.percent}
                    size="sm"
                    colorScheme="blue"
                    borderRadius="full"
                  />
                </Box>
              ))}
            </VStack>
          </CardBody>
        </Card>

        <Card bg={bgCard} borderColor={borderColor} borderWidth="1px">
          <CardHeader>
            <Heading size="md">Performance da Equipe</Heading>
          </CardHeader>
          <CardBody>
            <VStack spacing={4} align="stretch">
              {[
                { name: 'João Silva', processed: 23, pending: 12 },
                { name: 'Maria Santos', processed: 19, pending: 8 },
                { name: 'Pedro Costa', processed: 17, pending: 15 },
                { name: 'Ana Oliveira', processed: 15, pending: 10 },
                { name: 'Carlos Lima', processed: 12, pending: 7 }
              ].map((member) => (
                <Box key={member.name}>
                  <Flex justify="space-between" mb={1}>
                    <Text fontWeight="medium">{member.name}</Text>
                    <Text fontSize="sm" color="gray.500">
                      {member.processed} processados | {member.pending} pendentes
                    </Text>
                  </Flex>
                  <Progress
                    value={(member.processed / (member.processed + member.pending)) * 100}
                    size="xs"
                    colorScheme="green"
                    borderRadius="full"
                  />
                </Box>
              ))}
            </VStack>
          </CardBody>
        </Card>
      </SimpleGrid>
    </Box>
  );
};

export default GestorComercialDashboard;
